import css from './Footer.module.css'

const Footer = () => {

    return <div className={`container fluid ${css.Footer}`}>
        <p className="text md p-2">POKE-CSS build with &#10084; by Cosmin Neaga | cosmin.neaga91@gmail.com</p>
    </div>

}

export default Footer